module.exports = __webpack_public_path__ + "common/gh-icon-account-1727adffe160d0a81df9d5db187647c7.svg";